import * as z from "zod";

export enum PrintEngine {
  ENGINE4 = "Engine4",
  ENGINE5 = "Engine5",
  ENGINE6 = "Engine6",
  ENGINE7 = "Engine7",
}

export const ComputerPrintEngineSchema = z.object({
  engine: z.string(),
  observedAt: z.coerce.date(),
  ignored: z.boolean().optional(),
});

export type ComputerPrintEngine = z.infer<typeof ComputerPrintEngineSchema>;

export const ComputerPrintEnginesSchema = z.record(
  z.string(),
  ComputerPrintEngineSchema,
);

export type ComputerPrintEngines = z.infer<typeof ComputerPrintEnginesSchema>;

const ENGINE_IN_MESSAGE = /\busing (Engine\d+)\b/;

export function parsePrintEngine(message: string | undefined): string | null {
  return message?.match(ENGINE_IN_MESSAGE)?.[1] ?? null;
}

const RECOMMENDED_ENGINE_BY_ENGINE: Partial<Record<string, PrintEngine>> = {
  [PrintEngine.ENGINE6]: PrintEngine.ENGINE4,
  [PrintEngine.ENGINE7]: PrintEngine.ENGINE5,
};

export function recommendedPrintEngine(engine: string): PrintEngine | null {
  return RECOMMENDED_ENGINE_BY_ENGINE[engine] ?? null;
}

export enum PrintEngineRecommendationDismissal {
  DONE = "done",
  IGNORE = "ignore",
}
